// import React, { useContext, useEffect, useState } from 'react'
// import { useRouter } from 'next/router'
// import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import Layout from "../components/Layout";
// import {UserContext} from '../components/UserContext'
// import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import Link from "next/link";
// import Scrollspy from 'react-scrollspy';
// import Scroll from "./Scroll";
// import Modal from "react-modal";
// import OtpModal from "../components/OtpModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Carousel from 'react-multi-carousel';
// import Select from 'react-select'
import { Fade } from "./../components/Animation";
import "animate.css";
import Footer from "../components/Footer";
import FaqSolar from "../components/Faq";
import FormGstEstimate from "../components/FormGetEstiamte";
import { meta } from "../utils/meta";

// const responsive = {
//   Desktop: {
//     breakpoint: { max: 4000, min: 640 },
//     items: 1
//   },
//   mobile: {
//     breakpoint: { max: 640, min: 0 },
//     items: 1
//   }
// };

const Solar = () => {
  return (
    <Layout title={meta.solar.title} description={meta.solar.description} keywords={meta.solar.keywords}>
      <section className="bg-white pt-24 sm:pt-20 grid place-items-center home solar-page banner-mob-height">
        {/* <div className=""> */}
        <div className="p-6 container m-auto md:px-12 xl:px-24">
          <div className="">
            <div className="">
              <div className="flex flex-col justify-center xl:w-4/5 ">
                <h1 className="text-4xl xxs:text-5xl md:text-6xl font-configBold text-white">
                  Solar for Your <span className="text-primary">Home</span>
                </h1>
                <p className="text-base xxs:text-lg md:text-xl 2xl:text-2xl text-gray-100 py-2 font-primaryRegular lg:max-w-lg">
                  We make going solar a fast and easy process.
                </p>
                <div>
                  <Link href="/">
                    <a
                      className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium px-8 py-2.5 my-4 text-base md:text-lg 2xl:text-xl"
                    >
                      Get a Quote
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}

      </section>

      {/* <section className="bg-white pt-16">
        <div className="p-6 container m-auto md:px-4 xl:px-24">
          <div className="">
            <div className="">
              <div className="flex flex-col justify-center 2md:text-left text-center  ">
                <h2 className="text-center text-2xl xxs:text-4xl 2xl:text-5xl tracking-wide text-primary font-primaryMedium">
                  Go solar in five steps :
                </h2>
                <div className="border bg-primary border-primary my-3 w-14 mx-auto"></div>
                <h2 className="py-3 text-center mb-12 text-3xl sm:text-4xl md:text-5xl text-titleColor font-primaryMedium">
                  Get your Instant Quote for
                  <span className="font-primaryBold"> Switching to Solar</span>
                </h2>
                <div className="grid grid-cols-1 gap-12">
                  <div className="py-6">
                    <div className="w-11/12 float-right">
                      <img
                        src="./images/design.png"
                        className="object-contain pl-12"
                      />
                    </div>
                    <div className="box-width bg-white shadow-2xl left-0 absolute mt-20 p-12">
                      <div className="grid place-items-center">
                        <div className="flex items-center justify-center">
                          <span className="text-white bg-primary rounded-full text-xl  h-16 w-16 flex items-center justify-center">
                            1
                          </span>
                        </div>
                        <h4 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                          {" "}
                          Design
                        </h4>
                        <p className="tracking-wide text-center text-base xxs:text-base md:text-lg 2xl:text-3xl text-titleColor py-2 font-primaryMedium lg:max-w-lg">
                          {" "}
                          Your solar system will be uniquely designed by our
                          designers as per your requirements, building
                          structure, budget and so on.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="py-6">
                    <div className="w-11/12 float-right">
                      <img
                        src="./images/design.png"
                        className="object-contain pl-12"
                      />
                    </div>
                    <div className="box-width bg-white shadow-2xl right-0 absolute mt-20 p-12">
                      <div className="grid place-items-center">
                        <div className="flex items-center justify-center">
                          <span className="text-white bg-primary rounded-full text-xl  h-16 w-16 flex items-center justify-center">
                            2
                          </span>
                        </div>
                        <h4 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                          {" "}
                          Design
                        </h4>
                        <p className="tracking-wide text-center text-base xxs:text-base md:text-lg 2xl:text-3xl text-titleColor py-2 font-primaryMedium lg:max-w-lg">
                          {" "}
                          Your solar system will be uniquely designed by our
                          designers as per your requirements, building
                          structure, budget and so on.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="py-6">
                    <div className="w-11/12 float-right">
                      <img
                        src="./images/permit.png"
                        className="object-contain pl-12"
                      />
                    </div>
                    <div className="box-width bg-white shadow-2xl absolute mt-20  p-12">
                      <div className="flex items-center justify-center">
                        <span className="text-white bg-primary rounded-full text-xl  h-16 w-16 flex items-center justify-center">
                          3
                        </span>
                      </div>
                      <h4 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                        {" "}
                        Permitting
                      </h4>
                      <p className="tracking-wide text-center text-base xxs:text-base md:text-lg 2xl:text-3xl text-titleColor py-2 font-primaryMedium lg:max-w-lg">
                        {" "}
                        Our team will make sure all the municipal permits,
                        utility paperwork is taken care of.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="py-6">
                    <div className="w-11/12 float-right">
                      <img
                        src="./images/install.png"
                        className="object-contain pl-12"
                      />
                    </div>
                    <div className="box-width bg-white shadow-2xl absolute mt-20  p-12">
                      <div className="flex items-center justify-center">
                        <span className="text-white bg-primary rounded-full text-xl  h-16 w-16 flex items-center justify-center">
                          4
                        </span>
                      </div>
                      <h4 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                        {" "}
                        Installation
                      </h4>
                      <p className="tracking-wide text-center text-base xxs:text-base md:text-lg 2xl:text-3xl text-titleColor py-2 font-primaryMedium lg:max-w-lg">
                        {" "}
                        After the paperwork, the solar panels will be installed
                        on the roof by the Solar Quote team.
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="bg-white sm:pt-10 2md:pt-16">
        <div className="md:p-6 md:container m-auto md:px-4 xl:px-20">
          <div className="p-6 md:p-0">
            <h4 className="xxs:text-center text-xl xxs:text-3xl 2xl:text-4xl tracking-wide text-primary font-primaryMedium">
              Go solar in five steps :
            </h4>
            <div className="border bg-primary border-primary my-3 w-14 xxs:mx-auto"></div>
            <h2 className="sm:py-3 xxs:text-center md:mb-12 text-2xl xxs:text-3xl sm:text-4xl 2md:text-5xl text-titleColor font-configMedium">
              Get your Instant Quote for Switching to Solar
            </h2>
          </div>
          <div className="grid gap-24 xxs:gap-28 xxs:py-6">
            <div className="grid home consultation md:ml-28">
              <div className="md:container my-auto">
                <Fade triggerOnce delay={300} direction={'up'} className="mt-28 md:mt-0  flex flex-col items-center justify-center md:items-start md:justify-start">
                  <div className="w-11/12 md:w-3/4 2md:w-5/12 bg-white shadow-2xl px-4 xxs:px-8 py-6 mt-16 xxs:mt-0 xxs:py-12 md:-ml-28">
                    <div className="flex items-center justify-center">
                      <h5 className="text-white bg-primary rounded-full text-xl  h-10 xxs:h-16 w-10 xxs:w-16 flex items-center justify-center">
                        1
                      </h5>
                    </div>
                    <h3 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                      {" "}
                      Online Consultation
                    </h3>
                    <p className="leading-snug sm:line-height text-center text-sm xxs:text-base md:text-lg text-titleColor font-primaryMedium lg:max-w-lg">
                      Whether you would like to do a fully online quote and purchase, or speak to one of our solar experts, we will build a custom solar system designed for your home.
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="grid home designs md:mr-28">
              <div className="md:container my-auto">
                <Fade triggerOnce delay={300} direction={'up'} className="mt-36 md:mt-0  flex flex-col items-center justify-center md:items-end md:justify-end">
                  <div className="w-11/12 md:w-3/4 2md:w-5/12 bg-white shadow-2xl px-4 xxs:px-8 py-4 xxs:py-12 mt-16 xxs:mt-0 md:-mr-28">
                    <div className="flex items-center justify-center">
                      <h5 className="text-white bg-primary rounded-full text-xl h-10 xxs:h-16 w-10 xxs:w-16 flex items-center justify-center">
                        2
                      </h5>
                    </div>
                    <h3 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                      {" "}
                      Design
                    </h3>
                    <p className="leading-snug sm:line-height text-center text-sm xxs:text-base md:text-lg text-titleColor font-primaryMedium lg:max-w-lg">
                      {" "}
                      Your solar system will be uniquely designed based on
                      your energy requirements, building structure, budget and so on.
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="grid home permit md:ml-28">
              <div className="md:container my-auto">
                <Fade triggerOnce delay={300} direction={'up'} className="mt-36 md:mt-0  flex flex-col items-center justify-center md:items-start md:justify-start">
                  <div className="w-11/12 md:w-3/4 2md:w-5/12 bg-white shadow-2xl px-4 xxs:px-8 py-6 mt-16 xxs:mt-0 xxs:py-12 md:-ml-28">
                    <div className="flex items-center justify-center">
                      <h5 className="text-white bg-primary rounded-full text-xl  h-10 xxs:h-16 w-10 xxs:w-16 flex items-center justify-center">
                        3
                      </h5>
                    </div>
                    <h3 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                      {" "}
                      Permitting
                    </h3>
                    <p className="leading-snug sm:line-height text-center text-sm xxs:text-base md:text-lg text-titleColor font-primaryMedium lg:max-w-lg">
                      {" "}
                      Our team will make sure all the municipal permits
                      utility paperwork is taken care of
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="grid home install md:mr-28">
              <div className="md:container my-auto">
                <Fade triggerOnce delay={300} direction={'up'} className="mt-36 md:mt-0  flex flex-col items-center justify-center md:items-end md:justify-end">
                  <div className="w-11/12 md:w-3/4 2md:w-5/12 bg-white shadow-2xl px-4 xxs:px-8 py-4 xxs:py-12 mt-16 xxs:mt-0 md:-mr-28">
                    <div className="flex items-center justify-center">
                      <h5 className="text-white bg-primary rounded-full text-xl  h-10 xxs:h-16 w-10 xxs:w-16 flex items-center justify-center">
                        4
                      </h5>
                    </div>
                    <h3 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                      {" "}
                      Installation
                    </h3>
                    <p className="leading-snug sm:line-height text-center text-sm xxs:text-base md:text-lg text-titleColor font-primaryMedium lg:max-w-lg">
                      Once everything is approved, your solar panels will be installed by one of our Solar Quote partner installers.
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="grid home activation md:ml-28">
              <div className="md:container my-auto">
                <Fade triggerOnce delay={300} direction={'up'} className="mt-36 md:mt-0  flex flex-col items-center justify-center md:items-start md:justify-start">
                  <div className="w-11/12 md:w-3/4 2md:w-5/12 bg-white shadow-2xl px-4 xxs:px-8 py-6 mt-16 xxs:mt-0 xxs:py-12 md:-ml-28">
                    <div className="flex items-center justify-center">
                      <h5 className="text-white bg-primary rounded-full text-xl  h-10 xxs:h-16 w-10 xxs:w-16 flex items-center justify-center">
                        5
                      </h5>
                    </div>
                    <h3 className="py-3 text-center text-xl sm:text-2xl md:text-3xl text-titleColor font-primaryMedium">
                      {" "}
                      Activation
                    </h3>
                    <p className="leading-snug sm:line-height text-center text-sm xxs:text-base md:text-lg text-titleColor font-primaryMedium lg:max-w-lg">
                      The Solar Quote team will work with your utility company to connect your solar panels to the grid. Now you can start generating clean and renewable energy for your home.
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="xl:px-20 bg-gray-100">
        <section className="py-8 md:py-20">
          <div className="p-6 2md:p-4 lg:px-20 md:container md:m-auto flex flex-col-reverse 2md:grid 2md:grid-cols-2 gap-4 2md:gap-10 mt-12">
            <div className=" xxs:p-6 xl:p-0 my-auto">
              <h2 className="text-2xl xxs:text-3xl sm:text-4xl 2md:text-5xl text-titleColor font-configMedium max-w-md">How much do solar panels cost?
              </h2>
              <p className="text-titleColor py-2 sm:py-4 text-sm xxs:text-lg md:text-xl font-primaryMedium lg:w-10/12">
                Use our easy online solar panel calculator to get a quick estimate of how many solar panels you'll need for your home.
              </p>
              <Link href="/">
                <a
                  className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium px-8 py-2.5 lg:py-3 md:py-3 mb-2 mt-4 xxs:mb-4 text-base md:text-lg 2xl:text-xl"
                >
                  Get Estimate now
                </a>
              </Link>
            </div>
            <Fade triggerOnce delay={300}>
              <div className="py-6 px-4 xl:py-8">
                {/* <Link href="https://www.youtube.com/watch?v=O_MZqSz_Wwc&t=13s" passHref>
                  <a target='_blank'> */}
                <img src="./images/solar/solar-panels-cost.png"
                  className="object-contain w-full md:w-10/12 m-auto"
                  alt="Solar panel cost"
                />
                {/* </a>
                </Link> */}
              </div>
            </Fade>

          </div>
        </section>
      </div>
      <section className="bg-parallax-img get-instant-estimate py-12 relative bg-parallax-solar-page">
        <div className="p-6 container m-auto md:px-8 xl:px-24 text-center">
          <h3 className="xxs:text-center text-2xl xxs:text-4xl xl:text-4xl xl:leading-tight tracking-wide text-white font-configSemiBold relative w-full md:w-3/4 lg:w-2/4 m-auto mb-4">
            Are you doing your solar calculations right?
          </h3>
          <Link href="/">
            <a
              className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium px-12 sm:px-12  py-2.5 lg:py-3 my-4 text-base md:text-lg 2xl:text-xl w-auto max-w-320">
              Get estimate
            </a>
          </Link>
        </div>
      </section>
      <section className="bg-white py-4 pt-16">
        <div className="p-6 container m-auto md:px-4 xl:px-24">
          <div className="">
            <div className="">
              <h2 className="xxs:text-center text-2xl xxs:text-4xl 2xl:text-5xl tracking-wide text-titleColor font-configSemiBold">
                Frequently Asked <span className="text-primary">Questions</span>
              </h2>
              <p className="mx-auto line-height2 xxs:text-center text-sm xxs:text-base md:text-lg 2xl:text-xl text-titleColor py-2 font-primaryRegular lg:max-w-lg">
                FAQ's answer questions related to solar panels, savings, and
                how solar works
              </p>
            </div>
            <div className="py-10 md:w-3/4 mx-auto">
              <FaqSolar />
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 xxs:py-20 home contact-solar">
        <div className="py-4 px-8 xxs:py-4 xxs:px-4 container m-auto text-center xl:w-3/5">
          <FormGstEstimate />

          {/* <h3 className="tracking-tight 2xl:tracking-wide font-primaryMedium text-3xl xxs:text-4xl md:text-5xl text-white">
            Go Solar on Your Terms!
          </h3>
          <p className="tracking-wider text-white py-3 font-primaryMedium text-base xxs:text-lg md:text-xl">
            Take your first steps in creating a brighter future
          </p> */}
          {/* <form action="">
            <div className="grid sm:grid-cols-2 grid-cols-auto gap-4 xl:w-3/5 md:w-1/2 xxs:w-4/5 mx-auto py-4">
              <input
                type="text"
                placeholder="First Name"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Last Name"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Phone No"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Email"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="City"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Zip Code"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="State"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
              <input
                type="text"
                placeholder="Job Type"
                className="p-2.5 lg:p-2 rounded focus:outline-none font-primaryRegular text-sm"
              />
            </div>
            <div>
              <ReactWOW
                animation="fadeIn"
              >
                <a
                  href=""
                  className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium sm:px-12 
     py-2.5 lg:py-2 my-4 text-base md:text-lg 2xl:text-xl w-3/4 sm:w-auto"
                >
                  Get Started Now
                </a>
              </ReactWOW>
            </div>
            <p className=" font-primaryRegular text-sm line-height2 text-gray-400  sm:w-3/4 mx-auto">
              By submitting this form, you consent to receive emails, text
              messages and phone calls at any phone number you provide, even if
              the number is a wireless number. You agree that such calls and
              texts may be made using automated technology and that you are not
              required to provide consent to these calls to make a purchase from
              us.
            </p>
          </form> */}
        </div>
      </section>

      <Footer />
      <ToastContainer position="bottom-center" autoClose={8000} />
    </Layout>
  );
};

export default Solar;